<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="form-floating mb-3">
					<select class="form-select" id="status" name="status" [(ngModel)]="filters.status">
						<option value="">(wszystkie)</option>
						<option *ngFor="let item of statuses" [value]="item.id">
							{{ item.name }}
						</option>
					</select>
					<label for="status">Status</label>
				</div>
				<div class="form-floating mb-3">
					<select class="form-select" id="type" name="type" [(ngModel)]="filters.type">
						<option value="">(wszystkie)</option>
						<option *ngFor="let item of types" [value]="item.id">
							{{ item.name }}
						</option>
					</select>
					<label for="status">Rodzaj</label>
				</div>
				<div class="form-floating mb-3">
					<select class="form-select" id="objType" name="objType" [(ngModel)]="filters.objType">
						<option value="">(wszystkie)</option>
						<option *ngFor="let item of objTypes" [value]="item.id">
							{{ item.name }}
						</option>
					</select>
					<label for="objType">Rodzaj obiektu</label>
				</div>
			</div>
			<div class="modal-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm-4">
							<button type="button" class="btn btn-secondary" (click)="filtersClear()">
								Wyczyść filtry
							</button>
						</div>
						<div class="col-sm-8 text-end">
							<button type="button" class="btn btn-primary me-2" (click)="filtersSave()">Pokaż</button>
							<button
								type="button"
								class="btn btn-secondary"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
